module.exports = __webpack_public_path__ + "static/media/pic1.dd8a786f.jpg";